import { useMemo } from "react";

import { type MylensesManagementEntryPointTypes } from "@snapchat/blizzard-schema";

import { useSearchParams } from "../../shared/hooks/useSearchParams";
import { UTMSources } from "../models";

const UTM_SOURCE = "utm_source";

export const useEntryPoint = (): { defineEntryPoint: MylensesManagementEntryPointTypes } => {
    const searchParams = useSearchParams();
    const utmSource = searchParams.get(UTM_SOURCE);

    const defineEntryPoint = useMemo(() => {
        switch (utmSource) {
            case UTMSources.lensstudio:
                return "LENS_STUDIO_DESKTOP";
            case UTMSources.submission:
                return "MY_LENSES_SUBMISSION";
            default:
                return "WEB_ENTRY";
        }
    }, [utmSource]);

    return { defineEntryPoint };
};
